export default __webpack_public_path__ + "static/media/hellstrikes6.983b997f.png";